<template>
    <v-container fill-height fluid class="contacto">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-container pa-2 grid-list-md>
                        <v-layout row>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold brown--text text--darken-4"
                                >Contacto</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cerrar</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>

                        <v-layout row>
                            <v-flex xs12>
                                <v-container fluid>
                                    <v-layout row>
                                        <v-flex xs12 md4>
                                            <v-card max-width="90%" class="mx-auto">
                                                <v-img
                                                    src="../assets/sucursales/jeff-siepman-hK9hIPgF3QU-unsplash.jpg"
                                                    class="align-begin"
                                                    width="100%"
                                                    gradient="to bottom, rgba(255,255,255,1), rgba(0,0,0,.5)"
                                                >
                                                    <v-container>
                                                        <v-layout row justify-center>
                                                            <v-flex xs12 class="text-center">
                                                                <v-card-title
                                                                    class="red--text text--darken-4 cata_2 title-1 justify-center"
                                                                    style="white-space:pre-wrap;"
                                                                >Catabocata Santa Fe</v-card-title>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex
                                                                xs12
                                                                class="text-center brown--text text--darken-4 subtitle-1 justify-center"
                                                            >
                                                                <v-icon>mdi-email</v-icon>&nbsp; santafe@catabocata.com
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex
                                                                xs12
                                                                class="text-center brown--text text--darken-4 subtitle-1 justify-center"
                                                            >
                                                                <v-icon>mdi-phone</v-icon>&nbsp; (55) 5004-7787 y (55) 5004-8246.
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex xs12 class="text-center">
                                                                <v-tooltip bottom>
                                                                    <template
                                                                        v-slot:activator="{ on }"
                                                                    >
                                                                        <v-btn
                                                                            large
                                                                            class="text-none"
                                                                            icon
                                                                            @click="onFacebookSantaFe"
                                                                            v-on="on"
                                                                        >
                                                                            <img
                                                                                height="30"
                                                                                src="../assets/f_logo_RGB-Blue_58.png"
                                                                            />
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Facebook Catabocata Santa Fe</span>
                                                                </v-tooltip>
                                                            </v-flex>
                                                        </v-layout>

                                                        <template v-slot:placeholder>
                                                            <v-row
                                                                class="fill-height ma-0"
                                                                align="center"
                                                                justify="center"
                                                            >
                                                                <v-progress-circular
                                                                    indeterminate
                                                                    color="grey lighten-5"
                                                                ></v-progress-circular>
                                                            </v-row>
                                                        </template>
                                                    </v-container>
                                                </v-img>
                                            </v-card>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                            <v-card max-width="90%" class="mx-auto">
                                                <v-img
                                                    src="../assets/sucursales/lefteris-kallergis-etWlaoFnTl4-unsplash.jpg"
                                                    class="align-begin"
                                                    width="100%"
                                                    gradient="to bottom, rgba(255,255,255,1), rgba(0,0,0,.5)"
                                                >
                                                    <v-container>
                                                        <v-layout row justify-center>
                                                            <v-flex xs12 class="text-center">
                                                                <v-card-title
                                                                    class="red--text text--darken-4 cata_2 title-1 justify-center"
                                                                    style="white-space:pre-wrap;"
                                                                >Catabocata Avándaro</v-card-title>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex
                                                                xs12
                                                                class="text-center brown--text text--darken-4 subtitle-1 justify-center"
                                                            >
                                                                <v-icon>mdi-email</v-icon>&nbsp; avandaro@catabocata.com
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex
                                                                xs12
                                                                class="text-center brown--text text--darken-4 subtitle-1 justify-center"
                                                            >
                                                                <v-icon>mdi-phone</v-icon>&nbsp; (726) 110-0237 y (726) 266-1858
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex xs12 class="text-center">
                                                                <v-tooltip bottom>
                                                                    <template
                                                                        v-slot:activator="{ on }"
                                                                    >
                                                                        <v-btn
                                                                            large
                                                                            class="text-none"
                                                                            icon
                                                                            @click="onFacebookAvandaro"
                                                                            v-on="on"
                                                                        >
                                                                            <img
                                                                                height="30"
                                                                                src="../assets/f_logo_RGB-Blue_58.png"
                                                                            />
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Facebook Catabocata Avándaro</span>
                                                                </v-tooltip>
                                                            </v-flex>
                                                        </v-layout>

                                                        <template v-slot:placeholder>
                                                            <v-row
                                                                class="fill-height ma-0"
                                                                align="center"
                                                                justify="center"
                                                            >
                                                                <v-progress-circular
                                                                    indeterminate
                                                                    color="grey lighten-5"
                                                                ></v-progress-circular>
                                                            </v-row>
                                                        </template>
                                                    </v-container>
                                                </v-img>
                                            </v-card>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                            <v-container>
                                                <v-layout row>
                                                    <v-flex xs12>
                                                        <v-card max-width="90%" class="mx-auto">
                                                            <v-img
                                                                src="../assets/sucursales/icons8-team-r-enAOPw8Rs-unsplash.jpg"
                                                                class="align-begin"
                                                                width="100%"
                                                                gradient="to bottom, rgba(255,255,255,1), rgba(0,0,0,.5)"
                                                            >
                                                                <v-container>
                                                                    <v-layout row justify-center>
                                                                        <v-flex
                                                                            xs12
                                                                            class="text-center"
                                                                        >
                                                                            <v-card-title
                                                                                class="red--text text--darken-4 cata_2 title-1 justify-center"
                                                                                style="white-space:pre-wrap;"
                                                                            >Quejas y Sugerencias</v-card-title>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row justify-center>
                                                                        <v-flex
                                                                            xs12
                                                                            class="text-center brown--text text--darken-4 subtitle-1 justify-center"
                                                                        >
                                                                            <v-icon>mdi-email</v-icon>&nbsp; contacto@catabocata.com
                                                                        </v-flex>
                                                                    </v-layout>

                                                                    <template v-slot:placeholder>
                                                                        <v-row
                                                                            class="fill-height ma-0"
                                                                            align="center"
                                                                            justify="center"
                                                                        >
                                                                            <v-progress-circular
                                                                                indeterminate
                                                                                color="grey lighten-5"
                                                                            ></v-progress-circular>
                                                                        </v-row>
                                                                    </template>
                                                                </v-container>
                                                            </v-img>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs12></v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <!-- </section> -->
            </v-flex>
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- </div> -->
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'contacto',
    data() {
        return {};
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    created() {},
    computed: {
        ...mapGetters(['waitCursor', 'navMainLogo']),

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        },
        imgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '400px';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '350px';
            } else if (this.$vuetify.breakpoint.md) {
                width = '300px';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '250px';
            } else {
                width = '250px';
            }
            return width;
        },

        breakPoint() {
            var bkPoint = 'xs';
            if (this.$vuetify.breakpoint.sm) {
                bkPoint = 'sm';
            } else if (this.$vuetify.breakpoint.md) {
                bkPoint = 'md';
            } else if (this.$vuetify.breakpoint.lg) {
                bkPoint = 'lg';
            } else if (this.$vuetify.breakpoint.xl) {
                bkPoint = 'xl';
            }
            return bkPoint;
        }
    },
    methods: {
        onFacebookSantaFe() {
            window.open('https://www.facebook.com/CATABOCATAsantafe');
        },
        onFacebookAvandaro() {
            window.open('https://www.facebook.com/CATABOCATAavandaro/');
        },
        onClose() {
            this.$router.push('/');
        }
    }
};
</script>

<style scoped>
.contacto {
    background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%;
}

.sub-window {
    /* background-color: #e0e0e0;
    opacity: 0.3; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.3);
}

.bourbon {
    font-family: 'bourbon';
    font-weight: bold;
}

.catabocata-red {
    color: #bc1212;
}

.mainMenu {
    font-size: 80px;
}

.cata_2 {
    font-family: bourbon;
    /* font-size: 2.8em; */
    /* font-size: 500px; */
}

@font-face {
    font-family: bourbon;
    /*src: url(./sansumi-demibold.ttf);*/
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');*/
    src: url('../css/BourbonW00Regular.ttf');
}
</style>